import clsx from 'clsx'
import type { ReactNode } from 'react'

import { CommunityCardSlider } from '@/src/features/community/ui/components/CommunityCardSlider'
import { TEST_ID } from '@/src/general/constants/testId'
import { useDimensions } from '@/src/general/hooks/useDimensions'
import { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'
import { useRoutes } from '@/src/general/utils/routes'
import { useTranslate } from '@/src/lang/useTranslate'

import { COMMUNITIES_CATEGORY, EVENT_ORIGIN } from '../../../models/community.constants'
import { getCommunitiesCategoryQueryParams, useCommunitiesQuery } from '../../../services/useCommunitiesQuery'

export const TeamFavoritesSection = (): ReactNode => {
  const { t } = useTranslate()
  const { routes } = useRoutes()
  const { width } = useDimensions()

  const { data: teamFavorite } = useCommunitiesQuery(
    getCommunitiesCategoryQueryParams(COMMUNITIES_CATEGORY.TEAM_FAVORITES),
  )

  if (!teamFavorite || teamFavorite.length === 0) return null

  return (
    <CommunityCardSlider
      link={routes.communitiesCategory(COMMUNITIES_CATEGORY.TEAM_FAVORITES)}
      testID={TEST_ID.COMMUNITIES.FAVORITE_COMMUNITIES}
      title={t('community.communities.team-favorite')}
      list={teamFavorite}
      origin={EVENT_ORIGIN.TEAM_FAVORITES_SECTION}
      source={TRACKING_SOURCE.TEAM_FAVORITES_SECTION}
      classes={{ slider: clsx(width > 1400 && 'mx-6') }}
    />
  )
}
